import { Component, OnInit, forwardRef } from '@angular/core';
import { NavController, AlertController, LoadingController, ToastController, ActionSheetController, ModalController, NavParams, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AcompanhamentoPage } from '../acompanhamento.page';
import { BuscarPessoaPage } from '../../buscar-pessoa/buscar-pessoa.page';
import { AcompanhamentoProvider } from 'src/app/services/acompanhamento/acompanhamento';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { ImagePipe } from 'src/app/pipes/image/image';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';

@Component({
  selector: 'app-acompanhamento-add-resp',
  templateUrl: './acompanhamento-add-resp.page.html',
  styleUrls: ['./acompanhamento-add-resp.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    SemRegistroComponent
  ],
})
export class AcompanhamentoAddRespPage implements OnInit {
  acompanhamento: any = {};
  participanteList: any = [];
  responsavelList: any = [];
  filtro: any;
  constructor(public navCtrl: NavController,
    public alertCtrl: AlertController,
    private translate: TranslateService,
    public loadingController: LoadingController,
    public toastCtrl: ToastController,
    public acompanhamentoProvider: AcompanhamentoProvider,
    public actionSheetCtrl: ActionSheetController,
    public modalCtrl: ModalController,
    public navParams: NavParams
  ) {
    this.acompanhamento = this.navParams.data['acompanhamento'];
    this.participanteList = this.navParams.data['participantes'];
    if (this.navParams.get('responsaveis')) {
      this.responsavelList = this.navParams.get('responsaveis');
    }
  }

  ngOnInit() {
  }

  async add() {
    var modalPessoa = await this.modalCtrl.create({ component: BuscarPessoaPage, componentProps: { idOperacao: this.acompanhamento.idAcompanhamentoOperacao } });
    modalPessoa.present();

    const { data } = (await modalPessoa.onWillDismiss());
    if (data) {
      if (!this.responsavelList.find((responsavel: { id: string; }) => responsavel.id == data.pessoa.id)) {
        this.validarHorarioResponsavel(data.pessoa);
      }
    }
  }

  validarHorarioResponsavel(pessoa: { id: string; }) {
    let inicio = '';
    let fim = '';

    if (this.acompanhamento.id) {
      inicio = this.acompanhamento.datahora;
      fim = this.acompanhamento.dataHoraFim;
    } else {
      var dados = this.acompanhamentoProvider.tratarConteudo(this.acompanhamento, [], []);
      inicio = dados.acompanhamento.datahora;
      fim = dados.acompanhamento.dataHoraFim;
    }

    this.acompanhamentoProvider.validarHorarioResponsavel({ idPessoa: pessoa.id, inicio: inicio, fim: fim }).subscribe((data) => {
      !data.error ? this.responsavelList.push(pessoa) : this.confirmacao(pessoa);
    });

  }

  async confirmacao(pessoa: any) {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant('Atenção'),
      message: this.translate.instant('Esse responsável já possui um acompanhamento nesse horário. Deseja realmente marcar?'),
      buttons: [
        {
          text: this.translate.instant('Não'),
          handler: () => { }
        },
        {
          text: this.translate.instant('Sim'),
          handler: () => {
            this.responsavelList.push(pessoa);
          }
        }
      ]
    });
    alert.present();
  }

  async selecionarPessoa(pessoa: any) {
    let actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('Opções'),
      buttons: [
        {
          text: this.translate.instant('Remover Pessoa'),
          handler: async () => {
            let alert = await this.alertCtrl.create({
              cssClass: "alerta-personalizado",
              mode: "ios",
              header: this.translate.instant('Atenção'),
              message: this.translate.instant('Deseja remover essa pessoa desse acompanhamento?'),
              buttons: [
                {
                  text: this.translate.instant('Não'),
                  handler: () => { }
                },
                {
                  text: this.translate.instant('Sim'),
                  handler: () => {
                    this.responsavelList.splice(this.responsavelList.indexOf(pessoa), 1);
                  }
                }
              ]
            });
            alert.present();
          }
        },
      ]
    });

    actionSheet.present();
  }

  async finalizar() {
    if (this.responsavelList.length > 0) {
      const dados = this.acompanhamentoProvider.tratarConteudo(this.acompanhamento, this.participanteList, this.responsavelList);

      this.acompanhamentoProvider.salvarAcompanhamento(dados.acompanhamento, dados.participantes, dados.responsaveis).subscribe(async data => {
        this.modalCtrl.dismiss(dados);
        const toast = await this.toastCtrl.create({
          message: this.translate.instant('Acompanhamento criado com sucesso'),
          duration: 3000
        });
        toast.present();
      });

    } else {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant('Erro! Necessário informar no mínimo um resposável'),
        duration: 3000
      });
      toast.present();
    }
  }


  async salvar() {
    if (this.responsavelList.length > 0) {
      let ids: any[] = [];
      this.responsavelList.forEach((resp: { id: any; }) => {
        ids.push(resp.id);
      });

      this.acompanhamentoProvider.salvarPessoa(this.acompanhamento.id, ids, true).subscribe((data) => {
        this.modalCtrl.dismiss(data);
      });

    } else {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant('Erro! Necessário informar no mínimo um participante'),
        duration: 3000
      });
      toast.present();
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
